export default "__VITE_ASSET__CB$Rz7Bl__"